(() => {
  if (window.rzCartDrawerReady) return;
  window.rzCartDrawerReady = true;
  const root = () => window.Shopify?.routes?.root || '/';
  const readJSON = async (url, options) => {
    const response = await fetch(url, options), json = await response.json();
    if (!response.ok) throw new Error(json.description || json.message || 'Bitte versuche es erneut.');
    return json;
  };
  const updateOptions = data => ({method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});
  const refresh = () => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  const refreshComplete = () => new Promise(resolve => {
    const done = () => { clearTimeout(timer); document.removeEventListener('cart-drawer:refreshed',done); resolve(); };
    const timer = setTimeout(done,5000);
    document.addEventListener('cart-drawer:refreshed',done); refresh();
  });
  let changing = false;
  class RzCartDiscount extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const input = this.querySelector('[name="code"]');
      if (input && !input.parentElement.classList.contains('rz-cart-code-input')) {
        const wrap = document.createElement('div'); wrap.className='rz-cart-code-input'; input.before(wrap); wrap.append(input);
      }
      this.addEventListener('submit',event => {
        if (!event.target.matches('[data-rz-discount-form]')) return;
        event.preventDefault(); const code=input.value.trim(); if(code) this.apply(code);
      },{signal:this.abort.signal});
      this.addEventListener('click',event => { const button=event.target.closest('[data-rz-remove-code]'); if(button) this.apply(button.dataset.rzRemoveCode,true); },{signal:this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
    async apply(code,remove=false) {
      if(changing) return; changing=true;
      const error=this.querySelector('[data-rz-discount-error]'), input=this.querySelector('[name="code"]');
      error.hidden=true; this.setAttribute('aria-busy','true'); input.readOnly=true;
      this.querySelectorAll('button').forEach(button=>button.disabled=true);
      try {
        const cart=await readJSON(root()+'cart.js');
        const codes=(cart.discount_codes||[]).filter(entry=>entry.applicable).map(entry=>entry.code);
        const next=codes.filter(entry=>entry.toLowerCase()!==code.toLowerCase()); if(!remove) next.push(code);
        const result=await readJSON(root()+'cart/update.js',updateOptions({discount:next.join(',')}));
        const accepted=remove||result.discount_codes?.some(entry=>entry.applicable&&entry.code.toLowerCase()===code.toLowerCase());
        if(!accepted) { error.textContent='Dieser Code ist für deinen Warenkorb nicht gültig oder nicht kombinierbar.'; error.hidden=false; }
        else await refreshComplete();
      } catch(err) { error.textContent='Der Rabattcode konnte nicht aktualisiert werden. Bitte versuche es erneut.'; error.hidden=false; }
      finally { changing=false; this.removeAttribute('aria-busy'); input.readOnly=false; this.querySelectorAll('button').forEach(button=>button.disabled=false); }
    }
  }
  class RzCartRecommendation extends HTMLElement {
    connectedCallback() {
      this.abort=new AbortController();
      this.addEventListener('change',event=>{
        if(!event.target.matches('select[name="id"]')) return;
        const option=event.target.selectedOptions[0], compare=this.querySelector('[data-rz-rec-compare]');
        this.querySelector('[data-rz-rec-price]').textContent=option.dataset.price;
        compare.textContent=option.dataset.compare; compare.hidden=!option.dataset.compare;
        this.querySelector('[name="quantity"]').value=option.dataset.min||'1';
      },{signal:this.abort.signal});
      this.addEventListener('submit',event=>{if(!event.target.matches('[data-rz-recommendation-form]'))return;event.preventDefault();this.add(event.target);},{signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort();}
    async add(form){
      if(changing)return;changing=true;
      const button=form.querySelector('button'),error=this.querySelector('[data-rz-rec-error]');
      button.disabled=true;button.setAttribute('aria-busy','true');error.hidden=true;
      try{await readJSON(root()+'cart/add.js',updateOptions({items:[{id:form.elements.id.value,quantity:Number(form.elements.quantity.value)}]}));refresh();}
      catch(err){error.textContent=err.message||'Das Produkt konnte nicht hinzugefügt werden.';error.hidden=false;}
      finally{changing=false;button.disabled=false;button.removeAttribute('aria-busy');}
    }
  }
  class RzCartCarousel extends HTMLElement {
    connectedCallback(){
      this.abort=new AbortController();this.track=this.querySelector('.rz-cart-recommendations__track');this.controls=this.querySelector('.rz-cart-recommendations__arrows');
      this.prev=this.querySelector('[data-rz-carousel-prev]');this.next=this.querySelector('[data-rz-carousel-next]');if(!this.track||!this.controls)return;
      this.enableMouseDrag();
      const signal=this.abort.signal;this.prev.addEventListener('click',()=>this.move(-1),{signal});this.next.addEventListener('click',()=>this.move(1),{signal});
      this.track.addEventListener('scroll',()=>this.update(),{signal,passive:true});this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
    enableMouseDrag(){
      const track=this.track,signal=this.abort.signal;
      let drag=null,suppressUntil=0;
      const originalSnap=track.style.scrollSnapType;
      if(matchMedia('(hover:hover) and (pointer:fine)').matches)track.style.cursor='grab';
      const finish=event=>{
        if(!drag||event.pointerId!==drag.id)return;
        const state=drag;drag=null;
        if(state.moved){
          suppressUntil=Date.now()+400;
          if(track.hasPointerCapture(state.id))track.releasePointerCapture(state.id);
          track.style.scrollSnapType='none';
          track.style.scrollBehavior=state.behavior;
          track.style.userSelect=state.select;
          track.style.cursor='grab';
          this.update();
        }
      };
      track.addEventListener('pointerdown',event=>{
        if(event.pointerType!=='mouse'){track.style.scrollSnapType=originalSnap;return;}
        if(event.button!==0||event.target.closest('button,select,input,textarea,label'))return;
        suppressUntil=0;
        drag={id:event.pointerId,x:event.clientX,start:track.scrollLeft,moved:false,snap:track.style.scrollSnapType,behavior:track.style.scrollBehavior,select:track.style.userSelect};
      },{signal});
      window.addEventListener('pointermove',event=>{
        if(!drag||event.pointerId!==drag.id)return;
        const dx=event.clientX-drag.x;
        if(!drag.moved&&Math.abs(dx)<6)return;
        if(!drag.moved){drag.moved=true;track.style.scrollSnapType='none';track.style.scrollBehavior='auto';track.style.userSelect='none';track.style.cursor='grabbing';track.setPointerCapture(drag.id);}
        event.preventDefault();
        track.scrollLeft=Math.max(0,Math.min(track.scrollWidth-track.clientWidth,drag.start-dx));
      },{signal,passive:false});
      window.addEventListener('pointerup',finish,{signal});
      window.addEventListener('pointercancel',finish,{signal});
      track.addEventListener('lostpointercapture',finish,{signal});
      track.addEventListener('dragstart',event=>event.preventDefault(),{signal});
      track.addEventListener('click',event=>{if(Date.now()<suppressUntil){event.preventDefault();event.stopImmediatePropagation();}},{signal,capture:true});
    }
    update(){const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);this.controls.hidden=max<=2;this.prev.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft>=max-2;}
    move(direction){
      const max=this.track.scrollWidth-this.track.clientWidth,current=this.track.scrollLeft,origin=this.track.getBoundingClientRect().left;
      const positions=[...this.track.children].map(card=>Math.min(max,card.getBoundingClientRect().left-origin+current));
      const target=direction>0?positions.find(x=>x>current+3)??max:positions.reverse().find(x=>x<current-3)??0;
      this.track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
  }
  if(!customElements.get('rz-cart-carousel'))customElements.define('rz-cart-carousel',RzCartCarousel);
  if(!customElements.get('rz-cart-discount'))customElements.define('rz-cart-discount',RzCartDiscount);
  if(!customElements.get('rz-cart-recommendation'))customElements.define('rz-cart-recommendation',RzCartRecommendation);
  const hideDuplicateSavings=()=>{
    const footer=document.querySelector('#cart-drawer [slot="footer"]');if(!footer)return;
    const walker=document.createTreeWalker(footer,NodeFilter.SHOW_TEXT),matches=[];
    while(walker.nextNode())if(/^(?:du sparst|gesamt)\s*:?$/i.test(walker.currentNode.textContent.trim()))matches.push(walker.currentNode.parentElement);
    matches.forEach(label=>{
      if(label.closest('.rz-cart-savings, .rz-cart-shipping, .rz-cart-checkout, .rz-cart-checkout-note'))return;
      let row=label;
      for(let depth=0;depth<3&&row.parentElement!==footer;depth++){
        const parent=row.parentElement,text=parent.textContent.trim();
        if(parent.matches('form')||parent.querySelector('.rz-cart-savings, .rz-cart-shipping, button')||text.length>90)break;
        if(/gesamt/i.test(text)&&/du sparst/i.test(text))break;
        row=parent;if(/\d[\d.,\s]*\s*(?:€|EUR)/i.test(text))break;
      }row.hidden=true;
    });
  };
  const drawer=document.querySelector('#cart-drawer');
  if(drawer){hideDuplicateSavings();new MutationObserver(hideDuplicateSavings).observe(drawer,{childList:true,subtree:true});drawer.addEventListener('cart-drawer:refreshed',hideDuplicateSavings);}
})();
